<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Do & Cargo Arrival notice (Documentation)</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class id="vehicleBooking">
              <md-list>
                <md-list-item style="background:darkcyan !important;overflow:visible" id="showVisibility"
                  class="md-button-color-toggle md-active" @click="showOverflow">
                  <!-- v-bind:class="NocModel.ffDoId==''?'md-active':''"  -->
                  <span style="color:white">DOCUMENTATION - RELEASE DELIVERY ORDER</span>

                  <md-list-expand>
                    <md-list>
                      <div v-if="multiHAWBL.length>0 || NocModel.ffDoId!=''">
                        <md-layout md-gutter class="labelMargtop">


                          <md-layout md-flex="25">
                            <md-layout md-flex="100">
                              <label>Current Date & Time</label>
                              <b-form-input :formatter="capitalizeAll" disabled
                                v-model="NocModel.currentDate"></b-form-input>
                            </md-layout>
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="labelMargtop">


                          <md-layout md-flex="25">
                            <label v-if="NocModel.ffDoId==''">HBL Number</label>
                            <model-list-select v-if="NocModel.ffDoId==''" option-value="ffAirMultiBlId"
                              option-text="secondBLNumber" :list="HAWBLNoList" placeholder="Select HAWBL No."
                              v-model="NocModel.ffAirMultiBlId"></model-list-select>
                            <md-layout md-flex="100" v-else>
                              <label>HBL No</label>
                              <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo" v-model="NocModel.hblNo"
                                disabled></b-form-input>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="40">
                            <md-layout md-flex="100">
                              <label>Importer Name</label>
                              <b-form-input :formatter="capitalizeAll" id="importerName" name="importerName"
                                v-model="NocModel.importerName"></b-form-input>
                            </md-layout>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="25">
                            <md-layout md-flex="100">
                              <label>MBL No</label>
                              <b-form-input :formatter="capitalizeAll" id="mblNo" name="mblNo"
                                v-model="NocModel.mblNo"></b-form-input>
                            </md-layout>
                          </md-layout>

                          <md-layout md-flex="5"></md-layout>
                        </md-layout>
                        <md-layout md-gutter class="labelMargtop">


                          <md-layout md-flex="100">
                            <label>Container No./ Seal No.</label>
                            <quill-editor style="width:100% !important" ref="containerSealNo"
                              v-model="NocModel.containerSealNo"></quill-editor>
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="labelMargtop">


                          <md-layout md-flex="100">
                            <md-layout md-flex="100">
                              <label>Documentation Release Delievery Order</label>
                            </md-layout>
                            <md-layout md-flex="100">
                              <quill-editor style="width:100% !important;height:400px !important"
                                v-model="NocModel.nocPreparation"></quill-editor>
                            </md-layout>
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="gutr">


                          <md-layout md-flex="20">
                            <b-button class="mt-3" variant="primary" @click="addNocDocumentation"
                              id="addButtonLoaderNoc">Save & Submit DO Order</b-button>
                            <md-spinner md-indeterminate id="loaderNoc" style="display:none"></md-spinner>
                          </md-layout>

                          <md-layout md-flex="15"></md-layout>
                        </md-layout>
                      </div>

                      <div class="mt-4" v-if="DODocArray.length>0">
                        <!-- <div class="box-header">
                          <h3 class="box-title">Do Document Details</h3>
                        </div> -->

                        <!-- /.box-header -->
                        <div class="box-body">
                          <table id="ffBookingTentative" class="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>HAWBL No.</th>
                                <th>Importer Name</th>

                                <th>Print</th>
                                <!--  <th>Delete</th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item,index) in DODocArray" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{item.hblNo }}</td>
                                <td>{{item.importerName }}</td>
                                <td>
                                  <b-button variant="outline-dark" size="sm" class="ml-2" @click="viewEdit(item)">
                                    View / Edit
                                  </b-button>
                                  <b-button variant="outline-dark" size="sm" class="ml-2"
                                    @click="Print('AIR_IMPORT_DO_DOC_PDF',item.uploadNocDoc)">
                                    PDF
                                  </b-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </md-list>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>

            <hr class="hr-s">
            <div class="phone-viewport" id="railOut">
              <div>
                <md-list>
                  <md-list-item style="background:darkcyan !important;overflow:visible" id="showvehicleBooking"
                    class="md-button-color-toggle md-active">
                    <span style="color:white">Documentation ­- Cargo Arrival notice</span>

                    <md-list-expand>
                      <md-list>
                        <div v-if="HAWBLNoListCargo.length>0 || AuthModel.ffCargoId!=''">
                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="25">
                              <md-layout md-flex="100">
                                <label>Current Date & Time</label>
                                <b-form-input :formatter="capitalizeAll" disabled
                                  v-model="AuthModel.currentDate"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="100">
                              <md-layout md-flex="100">
                                <label>Important Notice</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important;height:160px !important"
                                  v-model="AuthModel.importantNotice"></quill-editor>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="100">
                              <md-layout md-flex="100">
                                <label>Notice Text</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important;height:90px !important"
                                  v-model="AuthModel.noticeText"></quill-editor>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="25">
                              <label v-if="AuthModel.ffCargoId==''">HBL Number</label>
                              <model-list-select v-if="AuthModel.ffCargoId==''" option-value="ffAirMultiBlId"
                                option-text="secondBLNumber" :list="HAWBLNoListCargo" placeholder="Select HAWBL No."
                                v-model="AuthModel.ffAirMultiBlId"></model-list-select>
                              <md-layout md-flex="100" v-else>
                                <label>HBL No</label>
                                <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo"
                                  v-model="AuthModel.secondBLNumber" disabled></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="40">
                              <md-layout md-flex="100">
                                <label>Shipper Name</label>
                                <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1"
                                  v-model="AuthModel.exporterName"></b-form-input>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="25">
                              <md-layout md-flex="100">
                                <label>MBL NO</label>
                                <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1"
                                  v-model="AuthModel.mblNo"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="25">
                              <md-layout md-flex="100">
                                <label>Airline Line Name</label>
                                <b-form-input :formatter="capitalizeAll" id="importerName" name="importerName"
                                  v-model="AuthModel.shippingLineName"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Consigned to.</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="containerSealNo"
                                  v-model="AuthModel.consignedTo"></quill-editor>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Vessel/Voyage</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="containerSealNo"
                                  v-model="AuthModel.vesselNameVoyage"></quill-editor>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Container No.</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="containerSealNo"
                                  v-model="AuthModel.containerSealNo"></quill-editor>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Origin</label>
                                <b-form-input :formatter="capitalizeAll" id="Origin" name="Origin"
                                  v-model="AuthModel.Origin"></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Destination</label>
                                <b-form-input :formatter="capitalizeAll" id="Destination" name="Destination"
                                  v-model="AuthModel.Destination"></b-form-input>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="10">
                              <md-layout md-flex="100">
                                <label>CBM</label>
                                <b-form-input :formatter="capitalizeAll" id="Measurement" name="Measurement"
                                  v-model="AuthModel.Measurement"></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <md-layout md-flex="100">
                                <label>SMTP No.</label>
                                <b-form-input :formatter="capitalizeAll" id="smtpNo" name="smtpNo"
                                  v-model="AuthModel.smtpNo"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>IGM No.</label>
                                <b-form-input :formatter="capitalizeAll" id="gatewayIgmNo" name="gatewayIgmNo"
                                  v-model="AuthModel.gatewayIgmNo"></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <label>IGM Date</label>
                              <date-picker lang="en" name="weighingDate" id="weighingDate" type="datetime"
                                format="YYYY-MM-DD hh:mm a" v-model="AuthModel.gatewayIgmDate"></date-picker>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <label>Arrival Date</label>
                              <date-picker lang="en" name="weighingDate" id="weighingDate" type="datetime"
                                format="YYYY-MM-DD hh:mm a" v-model="AuthModel.etaToPort"></date-picker>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="25">
                              <md-layout md-flex="100">
                                <label>Weight</label>
                                <b-form-input :formatter="capitalizeAll" id="grossWeight" name="grossWeight"
                                  v-model="AuthModel.grossWeight"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Local IGM No.</label>
                                <b-form-input :formatter="capitalizeAll" id="localIgmNo" name="localIgmNo"
                                  v-model="AuthModel.localIgmNo"></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="15">
                              <label>Local IGM Date.</label>
                              <date-picker lang="en" name="weighingDate" id="weighingDate" type="datetime"
                                format="YYYY-MM-DD hh:mm a" v-model="AuthModel.localIgmDate"></date-picker>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="5"></md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>No of packages</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="containerSealNo"
                                  v-model="AuthModel.noOfContainer"></quill-editor>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Actual Consignee</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="consignee"
                                  v-model="AuthModel.consignee"></quill-editor>
                              </md-layout>
                            </md-layout>
                            <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Commodity</label>
                              </md-layout>
                              <md-layout md-flex="100">
                                <quill-editor style="width:100% !important" ref="commodity"
                                  v-model="AuthModel.commodity"></quill-editor>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="100">
                              <md-layout md-flex="100">
                                <label>Remarks</label>
                                <b-form-textarea :formatter="capitalizeAll" id="mblNo1" name="mblNo1"
                                  v-model="AuthModel.remarks"></b-form-textarea>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="mt-3">


                            <md-layout md-flex="30">
                              <h5> <b-badge>Invoice Details</b-badge></h5>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="labelMargtop">

                            <md-layout md-flex="30">
                              <md-layout md-flex="100">
                                <label>Invoice No.</label>
                                <b-form-input :formatter="capitalizeAll" id="importerName" name="importerName"
                                  v-model="AuthModel.invoiceNo"></b-form-input>
                              </md-layout>
                            </md-layout>

                            <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="10">
                              <md-layout md-flex="100">
                                <label>Quantity</label>
                                <b-form-input :formatter="capitalizeAll" id="invQuantity" name="invQuantity"
                                  v-model="AuthModel.invQuantity"></b-form-input>
                              </md-layout>
                            </md-layout>
                          </md-layout>
                          <md-layout md-gutter class="labelMargtop">


                            <md-layout md-flex="100">
                              <md-layout md-flex="100">
                                <label>Description</label>
                                <b-form-textarea :formatter="capitalizeAll" id="invDescription" name="invDescription"
                                  v-model="AuthModel.invDescription"></b-form-textarea>
                              </md-layout>
                            </md-layout>
                          </md-layout>

                          <md-layout md-gutter class="gutr">


                            <md-layout md-flex="20">
                              <b-button class="mt-3" variant="primary" @click="addAuthDocumentation"
                                id="addButtonLoaderAuth">Save & Submit Cargo Notice</b-button>

                              <md-spinner md-indeterminate id="loaderAuth" style="display:none"></md-spinner>
                            </md-layout>
                            <md-layout md-flex="15"></md-layout>
                          </md-layout>
                        </div>

                        <div class="mt-4" v-if="CargoDocArray.length>0">
                          <!-- <div class="box-header">
                            <h3 class="box-title">Cargo Document Details</h3>
                          </div> -->

                          <!-- /.box-header -->
                          <div class="box-body">
                            <table id="ffBookingTentative" class="table table-bordered table-striped">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>HAWBL No.</th>
                                  <th>Exporter Name</th>

                                  <th>Action</th>
                                  <!--  <th>Delete</th> -->
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item,index) in CargoDocArray" :key="index">
                                  <td>{{index+1}}</td>
                                  <td>{{item.secondBLNumber }}</td>
                                  <td>{{item.exporterName }}</td>
                                  <td>
                                    <b-button variant="outline-dark" size="sm" @click="viewEditCargo(item)">
                                      View / Edit
                                    </b-button>
                                    <b-button class="ml-2" variant="outline-dark" size="sm"
                                      @click="Print('AIR_IMPORT_CARGO_ARIVAL_NOTIC_PDF',item.uploadCargoDoc)">
                                      PDF
                                    </b-button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </md-list>
                    </md-list-expand>
                  </md-list-item>
                </md-list>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop22"
      @close="onClose22"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopData"
      @close="ProceedSail"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/airImport/DOorderDocumentation"
      );

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }

    // this.vehicle();
  },
  watch: {
    NocModel: {
      handler: function(newVal, oldVal) {
        if (this.NocModel.ffAirMultiBlId != "") {
          let array = this.multiHAWBL.filter(x => {
            return x.ffAirMultiBlId == this.NocModel.ffAirMultiBlId;
          });
          console.log(array);
          if (array.length > 0) {
            this.NocModel.importerName = array[0].importerName;
            this.NocModel.containerSealNo = array[0].houseContainerSealNo;
            this.NocModel.hblNo = array[0].secondBLNumber;
          }
        }
      },
      deep: true
    },

    AuthModel: {
      handler: function(newVal, oldVal) {
        if (this.AuthModel.ffAirMultiBlId != "") {
          let array = this.cargoMultiHAWBL.filter(x => {
            return x.ffAirMultiBlId == this.AuthModel.ffAirMultiBlId;
          });
          console.log(array);
          if (array.length > 0) {
            this.AuthModel.exporterName = array[0].exporterName;
            this.AuthModel.containerSealNo = array[0].houseContainerSealNo;
            this.AuthModel.secondBLNumber = array[0].secondBLNumber;
            this.AuthModel.consignedTo =
              "<p>" +
              array[0].importerName +
              ",</p><p>" +
              array[0].corporateAddress +
              "</p>";
            this.AuthModel.consignedTo =
              "<p>" +
              array[0].importerName +
              ",</p><p>" +
              array[0].corporateAddress +
              "</p>";
            this.AuthModel.grossWeight = array[0].houseVolumeWeightCargo;
            this.AuthModel.noOfContainer = array[0].houseNoOfPkg;
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      NocModel: {
        ffDoId: "",
        ffAirMultiBlId: "",

        receivingDate: "",
        nocPreparation: "",
        currentDate: "",
        mblNo: "",
        hblNo: "",
        importerName: "",
        containerSealNo: "",

        uploadNocDoc: "",
        containerInfo: ""
      },
      AuthModel: {
        ffCargoId: "",

        ffAirMultiBlId: "",
        currentDate: "",
        shippingLineName: "",
        consignedTo: "",
        mblNo: "",
        exporterName: "",
        secondBLNumber: "",
        vesselNameVoyage: "",
        containerSealNo: "",
        Origin: "",
        Destination: "",
        Measurement: "",
        smtpNo: "",
        importantNotice: "",
        noticeText: "",
        gatewayIgmDate: "",
        etaToPort: "",
        grossWeight: "",
        gatewayIgmNo: "",
        localIgmNo: "",
        localIgmDate: "",
        commodity: "",
        remarks: "",
        noOfContainer: "",
        consignee: "",
        invoiceNo: "",
        invQuantity: "",
        invDescription: "",
        uploadCargoDoc: "",
        containerInfo: ""
      },

      sameAuth: {},
      NormalseaImportDataModel: {},

      railOutTableArray: [],
      deleteId: "",
      showVisible: false,

      validate: true,
      validateRail: true,
      toMain: "",
      toMainAuth: "",
      multiHAWBL: [],
      DODocArray: [],
      CargoDocArray: [],
      cargoMultiHAWBL: []
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    quillEditor
  },
  computed: {
    HAWBLNoList() {
      return this.multiHAWBL;
    },
    HAWBLNoListCargo() {
      return this.cargoMultiHAWBL;
    }
  },
  methods: {
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },

    Print(dir, value) {
      window.open(`${this.docURL}/` + dir + "/" + value);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },

    ProceedSail() {
      //   this.$router.push({
      //     path: "/ffExportCon/consoFclSailFpod"
      //   });
    },

    validateFFExport() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    viewEdit(item) {
      Object.keys(this.NocModel).map(x => {
        this.NocModel[x] = item[x];
      });
    },
    viewEditCargo(item) {
      Object.keys(this.AuthModel).map(x => {
        this.AuthModel[x] = item[x];
      });
    },

    showOverflow() {},

    addNocDocumentation() {
      if (this.NocModel.ffAirMultiBlId == "") {
        this.alert.content = "Please Select HBL Number";
        this.$refs["addPop"].open();
        return false;
      }
      this.NocModel["ffairImportId"] = this.$sessionsStorage.get(
        "editffAirImportId"
      );
      //   this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoaderNoc").css("display", "none");
        $("#loaderNoc").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addDODoc.php`,
          data: JSON.stringify(this.NocModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderNoc").css("display", "none");
              $("#addButtonLoaderNoc").css("display", "block");
              if (this.NocModel.ffDoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              this.NocModel.hblNo = "";
              this.NocModel.ffAirMultiBlId = "";
              this.NocModel.ffDoId = "";
              // this.NocModel.ffDoId = data.ffDoId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addAuthDocumentation() {
      if (this.AuthModel.ffAirMultiBlId == "") {
        this.alert.content = "Please Select HBL Number";
        this.$refs["addPop"].open();
        return false;
      }

      this.AuthModel["ffairImportId"] = this.$sessionsStorage.get(
        "editffAirImportId"
      );
      //   this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoaderAuth").css("display", "none");
        $("#loaderAuth").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addCargoDoc.php`,
          data: JSON.stringify(this.AuthModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if ( status == 200 && data) {
              $("#loaderAuth").css("display", "none");
              $("#addButtonLoaderAuth").css("display", "block");

              if (this.AuthModel.ffCargoId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = "";
              });
              // this.AuthModel.ffCargoId = data.ffCargoId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    onClose22() {},

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    getData() {
      let vehicle_drive = {
        ffairImportId: this.$sessionsStorage.get("editffAirImportId")
      };
      this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirImport/fetch_DO_Cargo_Documentation.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);

            Object.keys(data.NormalseaImportData[0]).map(x => {
              this.NormalseaImportDataModel[x] =
                data.NormalseaImportData[0][x] || "";
            });

            if (data.NormalseaImportDataArray.length > 0) {
              this.multiHAWBL = data.NormalseaImportDataArray;
              this.NocModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              this.NocModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.NocModel.currentDate = this.formatDate(new Date());

              if (data.LastPreparationNoc.length > 0) {
                this.NocModel.nocPreparation =
                  data.LastPreparationNoc[0].nocPreparation;
              } else {
                this.NocModel.nocPreparation =
                  "<b><br/><br/><p>To,</p><p>Seabridge Maritime Agencies Pvt. Ltd.</p><p>Kolkata.</p><p>Kind attn: Import Dept.</p></b><br/><p>Dear Sir</p><p>Sub: MBL No: <b><<--From Input MBL->></b></p><p>HBL NO: <b><<--From Input HBL->></b></p><p>Container no: </p><p><<--From Input Container->></p><br/><p>Ref to the above shipment, we are enclosing you the copy of Seaway HBL and MBL copy duly endorsed by us for your reference.</p><p>Also we have no objection to release the container for factory destuffing.</p><br/><b><p>Thanking you,</p><br/><p>For Eagle Maritime pvt Ltd</p><p>Auth. Signatory.</p></b>";
              }
            } else {
              this.multiHAWBL = [];
            }

            if (data.NocDocumentArray.length > 0) {
              this.DODocArray = data.NocDocumentArray;
            } else {
              this.DODocArray = [];
            }

            if (data.CargoBLArray.length > 0) {
              this.cargoMultiHAWBL = data.CargoBLArray;
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.NormalseaImportData[0][x] || "";
              });
              this.AuthModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.AuthModel.currentDate = this.formatDate(new Date());

              if (data.LastAuthLetter.length > 0) {
                this.AuthModel.importantNotice =
                  data.LastAuthLetter[0].importantNotice;
                this.AuthModel.noticeText = data.LastAuthLetter[0].noticeText;
              } else {
                this.AuthModel.importantNotice =
                  "<p>1. THE BELOW SHIPMENT ARRIVERD / EXPECTED AT NHAVA SHEVA ON DATE 20/04/2012.<br/>PLEASE KEEP IN TOUCH WITH US FOR FURTHER INFORMATION AND ARRANGE TO PRESENT ORIGINAL / ENDORESED DOCUMENT AND OBTAIN DELIVERY ORDER AGAINST PAYMENT OF ALL CHARGES THROUGH D.D.</p><p>2 A) PELASE PRODUCE LETTER OF AUTHORITY WHILE APPROCHING US FOR DOCUMENTS AND DO.<br/>  &nbsp;&nbsp;&nbsp;B) FOR PERSONAL EFFECTS PLEASE PRODUCE YOUR PASSPORT AND AUTHORITY LETTER  AT THE TIME OF COLLECTING DELIVERY ORDER. </p><p>3. PAYMENT IS TO BE MADE STRICTY IN DD/ CASH ACCORDING TO OUR FREIGHT INVOICE. </p><p>4 EXCHANGE RATE APPLIED IS SUBJET TO ANY UPWARD REVISION. </p>";

                this.AuthModel.noticeText =
                  "<p>Dear Sir / Madam,</p><br/><p>We have the please in advising you arrivial of the following shipment to you under our consolidation service which are as per details below .</p>";
              }
            } else {
              this.cargoMultiHAWBL = [];
            }

            if (data.AuthDocumentArray.length > 0) {
              this.CargoDocArray = data.AuthDocumentArray;
            } else {
              this.CargoDocArray = [];
            }

            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      // console.log(this.handover);
      // return false;

      this.$router.push({
        path: "/airImport/airImportExec"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

/* .activeClass {
  display: none;
} */
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// airImportDOorderDocumentation.vue?fe7f9e92